import type { Ref } from 'vue';
import type { FieldTypeFilterConfig } from '#layers/data-model/public';
import type { SegmentedFieldFilter } from './utils/filter-path';
import type { FilterSchemaPrimitiveField } from './utils/filter-schema';
import { createContext } from 'reka-ui';

/** Private context for FilterInputGroup delegation — not for external use */
export interface FilterInputGroupDelegateContext {
	primitiveField: Ref<FilterSchemaPrimitiveField>;
	filterConfig: Ref<FieldTypeFilterConfig | undefined>;
	typeOptions: Ref<Record<string, unknown>>;
	model: Ref<SegmentedFieldFilter | null>;
	disabled: Ref<boolean>;
	readonly: Ref<boolean>;
}

export const [injectFilterInputGroupDelegateContext, provideFilterInputGroupDelegateContext] =
	createContext<FilterInputGroupDelegateContext>('FilterInputGroupDelegate');
